import { tns } from 'tiny-slider'
import { registerComponent } from '../components-front';

registerComponent('course-carousel', _ => {
    document.querySelectorAll('.course-carousel-wrapper').forEach(carouselWrapper => {
        const carousel = carouselWrapper.querySelector('.course-carousel')
        const cols = carousel.dataset.cols || 2

        /** @var {HTMLDivElement} prev */
        const prev = carouselWrapper.querySelector('.prev')
        /** @var {HTMLDivElement} next */
        const next = carouselWrapper.querySelector('.next')

        const slider = tns({
            container: carousel,
            items: Math.max(2, Math.floor(cols / 2)),
            slideBy: 1,
            gutter: 20,
            loop: false,
            nav: false,
            mouseDrag: true,
            prevButton: prev,
            nextButton: next,
            arrowKeys: true,
            lazyload: true,
            responsive: {
                768: {
                    items: Math.max(3, Math.floor(cols * 0.75)),
                },
                992: {
                    items: cols,
                },
            },
        })
    })
})
